import { Prompt } from 'api/model';
import { DEFAULT_NEW_PROMPT_REVISION } from './LLMCommonForm';

type EvaluationFields = {
  evaluation_model_id?: string;
  evaluation_prompt_id?: string;
  evaluation_prompt_revision?: number;
  evaluation_operator?: string;
  evaluation_expected_value?: string;
  evaluation_max_retries?: number;
  expand_evaluation_settings?: boolean;
};

export const resetEvaluationSettings = (configuration: EvaluationFields) => {
  configuration.evaluation_model_id = undefined;
  configuration.evaluation_prompt_id = undefined;
  configuration.evaluation_prompt_revision = undefined;
  configuration.evaluation_operator = undefined;
  configuration.evaluation_expected_value = undefined;
  configuration.evaluation_max_retries = undefined;
};

export const prepareEvaluationInitialValues = (configuration: EvaluationFields) => {
  const expand = Boolean(configuration.evaluation_model_id || configuration.evaluation_prompt_id);
  configuration.expand_evaluation_settings = expand;
  if (!expand) {
    resetEvaluationSettings(configuration);
  }
};

export const handleEvaluationChange = (
  newConfiguration: EvaluationFields,
  previousConfiguration?: EvaluationFields,
  prompts?: Prompt[],
) => {
  const evaluationPromptId = newConfiguration.evaluation_prompt_id;
  if (!evaluationPromptId) {
    newConfiguration.evaluation_prompt_revision = undefined;
  } else if (evaluationPromptId !== previousConfiguration?.evaluation_prompt_id) {
    const evaluationPrompt = prompts?.find((p) => p.id === evaluationPromptId);
    newConfiguration.evaluation_prompt_revision = evaluationPrompt
      ? evaluationPrompt.revision
      : DEFAULT_NEW_PROMPT_REVISION;
  }

  if (!newConfiguration.expand_evaluation_settings && previousConfiguration?.expand_evaluation_settings) {
    resetEvaluationSettings(newConfiguration);
  }
};
